import { Navigate } from 'react-router-dom';
import { useAuth } from '@/shared/lib/auth';
import { usePassbook } from '@/shared/lib/passbook';
import { firstAllowedCampaignPath } from '@/shared/lib/navigation';
import { FullPageLoader } from '@/shared/components/full-page-loader';

/** `/campanhas` → primeiro subitem permitido pela role + flags (não sempre `manual`). */
export function CampaignsIndexRedirect() {
  const { user, isLoading } = useAuth();
  const { idPassbook, passbook } = usePassbook();

  if (isLoading || !user) return <FullPageLoader />;

  const base = `/loja/${idPassbook}`;
  const target = firstAllowedCampaignPath(user.role, passbook, base);
  if (!target) {
    return <Navigate to={user.role === 'Operator' ? `${base}/leads` : base} replace />;
  }
  return <Navigate to={target} replace />;
}
